<template>
  <div id="app">
    <Layout>
      <Header class="header">
        <router-link to="/">
          <div class="logo">Leap Learning</div>
        </router-link>
        <div class="nav">
          <a href="https://webapps.leaplearning.no"><Button>Webapps</Button></a>
          <a href="https://play.google.com/store/apps/details?id=no.leaplearning.launcher"><Button>Android</Button></a>
          <a href="https://apps.apple.com/no/app/leap-learnings-app-universe/id1489716738"><Button>iOS</Button></a>
          <router-link to="/logout" v-show="isLoggedIn"><Button>Logout</Button></router-link>
        </div>
      </Header>
      <Layout>
        <Content class="main-content">
          <router-view></router-view>
        </Content>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'app',
  data() {
    return {
      loggedIn: false
    }
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.license.isLoggedIn
    }),
  },
  methods: {
    login(event) {
      this.loggedIn = event;
    }
  }
}
</script>

<style lang="scss">
body {
  font-family: 'Lato', 'Avenir', Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  /* Set minimum page width to 1000px, as scaling doesn't work on mobile */
  min-width:1000px;
  width: auto !important;
  width: 1000px;
}
#app {
  width: 1px;
  min-width: 100%;
}
.header, .ivu-layout-header {
  background: #fff !important;
  font-size: 1.5em;
  border-bottom: 1px solid #ccc;

  @include respond-to(phone) {
    font-size: 1em;
  }
}
.logo {
  float: left;
  color: #333;
}
.nav {
  float: right;

  a:not(:last-child) {
    margin-right: 15px;
  }
}
.main-content {
  height: calc(100vh - 64px);
}
</style>
